import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { useMount } from 'react-use';
import Languages from '../../../../../../containers/sections/satisfaction/languages';
import { GlobalCsatSwitch } from '../../common/GlobalCsatSwitch';
export const ChatPanel = (props) => {
    var _a;
    useMount(() => {
        props.loadSettingsAllLevels();
    });
    const getEnrichedLanguagesWithSettings = () => {
        return props.languagesSettings.list.map(({ code, label, settings }) => ({
            isSetup: settings !== null,
            ratingStyle: settings === null || settings === void 0 ? void 0 : settings.customization.look_and_feel,
            enabled: (settings === null || settings === void 0 ? void 0 : settings.enabled) || false,
            name: label,
            code,
            settings,
        }));
    };
    const handleGlobalStatusChange = (change) => {
        // If we have global settigns already, update it
        if (props.globalSettings.values) {
            props.updateGlobalSettings(Object.assign(Object.assign({}, props.globalSettings.values), { enabled: change.newStatus }));
        }
        else {
            // Otherwise csat is not initialized , so initialize if needed.
            if (change.newStatus) {
                props.initializeChatCsat();
            }
        }
    };
    const handleLanguageStatusChange = ({ language, newStatus }) => {
        var _a, _b, _c;
        // the default language should not be allowed to be disabled.
        if (((_b = (_a = props.globalSettings) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.language) === language.code) {
            return;
        }
        const payload = {
            id: (_c = language.settings) === null || _c === void 0 ? void 0 : _c.id,
            enabled: newStatus,
            channel: 'widgetchat',
        };
        props.updateLanguageLevelSettings(payload);
    };
    const { globalSettings } = props;
    const isActive = ((_a = globalSettings.values) === null || _a === void 0 ? void 0 : _a.enabled) || false;
    return (_jsx(Page.Section, Object.assign({ callout: _jsx(GlobalCsatSwitch, { onChange: handleGlobalStatusChange, channel: "widgetchat", isActive: isActive }) }, { children: _jsx(Languages, { languages: getEnrichedLanguagesWithSettings(), onLanguageStatusChange: handleLanguageStatusChange }) })));
};
